/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import { IssueStatusEnum } from '../../types';
import ManagerNote from './ManagerNote';
import IssueLayout from './IssueLayout';
import './styles.scss';
export default function MissingTimeEntryIssueCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false, settings }) {
    var _a, _b;
    const status = issue.status || IssueStatusEnum.Detected;
    const isHighImpact = issue.status !== IssueStatusEnum.Resolved && ((_a = issue.issueData) === null || _a === void 0 ? void 0 : _a.highImpact) === true;
    // Handler functions for issue actions
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const handleNoteChange = (note) => {
        onUpdateIssue(issue.id, status, issue.markedForSuggestion, note);
    };
    // Create high impact badge if needed
    const highImpactBadge = isHighImpact ? (React.createElement("span", { className: "issue-card__badge issue-card__badge--high-impact" }, translate('high_impact', { namespace: 'features.iim_review.issue_card' }))) : undefined;
    return (React.createElement(IssueLayout, { issueType: "missing_time_entries", badge: highImpactBadge, status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion },
        React.createElement(React.Fragment, null,
            React.createElement("p", null, translate('missing_time_entries_description', { namespace: 'features.iim_review.issue_card' })),
            issue.markedForSuggestion && (!readOnly || ((_b = issue.managerNote) === null || _b === void 0 ? void 0 : _b.trim())) && (React.createElement("div", { className: "issue-card__body" },
                React.createElement(ManagerNote, { note: issue.managerNote || '', onNoteChange: handleNoteChange, disabled: readOnly }))))));
}
